import type { HostActions } from '@makemydeal/activities-tradein';
import { hideGlobalSpinner, setDealAcceptedByBuyer, updateActiveDealVisibilityStatus } from '@makemydeal/dr-sales-checkin-store';

export const hostActions: HostActions = {
    relayTradeInEvents: (payload: any) => ({ type: 'RELAY_TRADE_IN_EVENTS', payload }),
    hideGlobalSpinner,
    setDealAcceptedByBuyer,
    updateActiveDealVisibilityStatus
};
